import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import Select from "./Select";

const FormikSelect = ({
    ariaRequired = "false",
    label,
    name,
    validate = () => {},
    ...props
}) => {
    const formikProps = {
        name,
        validate,
    };
    const [{ onBlur, onChange, value, ...field }, meta] = useField(formikProps);
    // Transform the error and touched values into a boolean that can be used
    // to determine whether or not the error message should be displayed
    const hasError = Boolean(meta.error);
    const hasBeenTouched = meta.touched;
    const shouldDisplayError = hasError && hasBeenTouched;
    const fieldProps = {
        ariaRequired: ariaRequired,
        handleBlur: onBlur,
        handleChange: onChange,
        value: value ? value : "",
        error: shouldDisplayError,
        errorText:
            meta.error === "Required" ? `${label} is required` : meta.error,
        label,
        ...props,
        ...field,
    };

    return <Select {...fieldProps} />;
};

FormikSelect.propTypes = {
    ariaRequired: PropTypes.string,
    // Field Name
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    // Optional field-level validation
    validate: PropTypes.func,
};

export default FormikSelect;
